import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Question } from '@app/models/question.model';
import { ResponseQuestion } from '@app/models/responseQuestion.model';
import { ModalService } from '@app/services/modal.service';
import { SatisfactionService } from '@app/services/satisfaction.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-rate-your-experience',
  templateUrl: './modal-rate-your-experience.component.html',
  styleUrls: ['./modal-rate-your-experience.component.scss']
})
export class ModalRateYourExperienceComponent implements OnInit, OnChanges {

  @Input() dataQuestions: Question[];
  
  private dataUser: any;
  public dataRateActive: Question;
  public valueRate: string | null = null;
  public lastActive: boolean = false;
  questionId: number;

  constructor(
    public modal:ModalService,
    public rateservice: SatisfactionService
  ) { }

  ngOnInit(): void { 
    this.dataUser = JSON.parse(sessionStorage.getItem('user') || '');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes.dataQuestions) {
      this.sortDataQuestions();
    }
  }

  sortDataQuestions() : void {
    this.dataQuestions = this.dataQuestions.sort((a: Question, b: Question) => a.questionsOrder - b.questionsOrder);
    this.setQuestionActive(0);
  }

  setQuestionActive(index: number) {
    this.dataRateActive = this.dataQuestions[index];
    this.questionId = this.dataRateActive.questionId;
  }

  handleActionNext() : void {
    const indexActive = this.dataQuestions.findIndex((question:Question) => question.questionId == this.dataRateActive.questionId);
    if ( indexActive <= (this.dataQuestions.length-1) && indexActive !== -1 ) this.uploadAnswerService(indexActive + 1);
    if ( indexActive == (this.dataQuestions.length-1)) { this.lastActive = true; }
    
  }

  uploadAnswerService(index:number) : void {
    const params = this.setParamsRequest();
    this.rateservice.postResponseQuestion(params).subscribe({
      next: (success) => {
        this.valueRate = null;

        if (this.lastActive) {
          this.modal.close();
          this.modal.show('modalSuccessRate');
          this.rateservice.setResetRating(true);
        }

        else this.setQuestionActive(index);
        
        console.log(success)
      },
      error: (e:any) => {
        Swal.fire({
          type: 'error',
          title: 'Alerta:',
          text: e.error.message || 'Error al guardar la respuesta',
        });
      }
    })
  }

  setParamsRequest() {
    const params = new ResponseQuestion();
    const { openedQuestion, starQuestion, emojiQuestion } = this.dataRateActive;
    params.questionId = {...this.dataRateActive, activeQuestion: false};
    params.openedResponse = openedQuestion ? this.valueRate : null;
    params.starResponse = starQuestion ? Number(this.valueRate) : null;
    params.emojiResponse = emojiQuestion ? this.homologationValueScore(Number(this.valueRate)) : null;
    params.userId = this.dataUser.userEmail;
    params.userDocumentType = this.dataUser.userInfo.TIPO_DOCUMENTO_USUARIO;
    params.userDocument = this.dataUser.userInfo.DOCUMENTO_USUARIO;
    params.responseDate = new Date();
    params.responseComents = emojiQuestion ? this.valueRate : '';

    return params;
  }

  homologationValueScore(value: number) : string {
    const valueScoreByQuestion: {[key: number] : () => string } = {
      9: () : string => {
        // ID:9 / Teniendo en cuenta tu experiencia, ¿qué tan satisfecho estás con el funcionamiento de la página web?
        if (value >= 8 && value <= 10)  return 'Satisfecho';
        if (value >= 4 && value <= 7)  return 'Neutro';
        if (value >= 1 && value <= 3)  return 'Insatisfecho';
        else return '';
      },
      7: () : string => {
        // ID:7 / Teniendo en cuenta tu experiencia, ¿qué tan satisfecho estás con el funcionamiento de la página web ?
        if (value >= 8 && value <= 10)  return 'Promotores';
        if (value >= 4 && value <= 7)  return 'Neutro';
        if (value >= 0 && value <= 3)  return 'Detractores';
        else return '';
      }
    }

    return valueScoreByQuestion[this.dataRateActive.questionId]() || String(value);
  }

  get validateValue(): boolean {
    return this.valueRate ? false : true ;
  }

  get icon() : string {
    const iconByIdQuestion = {
      6 : 'icon__nut',
      9 : 'icon__world',
      7 : 'icon__hands',
      8 : 'icon__light',
      10 : 'icon__dart',
    }

    return iconByIdQuestion[this.dataRateActive.questionId] || '';
  }

  get showSecondDescription() : boolean {
    const questionsIDs: number[] = [6, 8];
    return questionsIDs.includes(this.dataRateActive.questionId) || false;
  }

}